import { render } from "./SidebarInfo.vue?vue&type=template&id=198154d7&scoped=true"
import script from "./SidebarInfo.vue?vue&type=script&lang=js"
export * from "./SidebarInfo.vue?vue&type=script&lang=js"

import "./SidebarInfo.vue?vue&type=style&index=0&id=198154d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198154d7"]])

export default __exports__